<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="门店名称：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入门店名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="editBtn('')" size="small" type="primary" class="bg-theme">添加门店</el-button>
      </div>
      <div class="text item">
        <el-table
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="loginName"
            label="登录账号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="shopName"
            label="门店名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="shopLogo"
            label="门店logo">
            <template slot-scope="scope">
              <el-image
                style="width: 88px;"
                :src="scope.row.shopLogo"
                :preview-src-list="[scope.row.shopLogo]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="startBusinessTime"
            label="开始营业时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="endBusinessTime"
            label="结束营业时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="linkName"
            label="联系人">
          </el-table-column>
          <el-table-column
            align="center"
            prop="linkPhone"
            label="联系电话">
          </el-table-column>
          <el-table-column
            align="center"
            prop="address"
            label="详细地址">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="添加时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            label="设为默认">
            <template slot-scope="scope">
              <el-image
                @click="setDefaultBtn(scope.row.id)"
                style="width: 24px;"
                :src="scope.row.isDefault == 1 ? imgServer+'choosed_icon.png' : imgServer+'choose_icon.png'"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryShopInfoPageList, removeShopInfoById, updateShopInfoStatus, updateShopInfoDefault } from '@/api/shop'
export default {
  name: 'ShopList',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryShopInfoPageList({ shopName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/shop_list_add', query: {dataId: infoId}})
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      updateShopInfoStatus({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {}
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    setDefaultBtn(infoId){
      let that = this
      this.$confirm('确认设为默认？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        updateShopInfoDefault({ id: infoId}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            that.getInfoList()
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeShopInfoById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/shop/List.vue